import { create } from 'zustand';
import type { IDialogStore } from '../hooks/dialogStore/DialogStore.types';

export const zustandDialogStore = create<IDialogStore>(set => ({
  dialogs: [],
  setDialogs: dialogs => set({ dialogs }),
}));
